import './CorrelChart.css';

interface CorrelChartProps {
  answerLabel: string;
  counts: Record<number, number>;
  answerChoices: string[];
}

function CorrelChart({ answerLabel, counts, answerChoices }: CorrelChartProps) {
  // Calculate total for this subset
  const total = Object.values(counts).reduce((sum, count) => sum + count, 0);

  // Calculate percentage for each bar
  const calculatePercentage = (count: number): number => {
    if (total === 0) return 0;
    return Math.round((count * 100) / total);
  };

  // Generate grayscale color based on index
  const getBarColor = (index: number): string => {
    const numChoices = answerChoices.length;
    // Range from 80% (light) to 20% (dark)
    const lightness = 80 - (index / numChoices) * 60;
    const hue = 360 - (index / numChoices) * 360;
    return `hsl(${hue}, 0%, ${lightness}%)`;
  };

  return (
    <div className="correl-chart">
      <div className="correl-chart__bars">
        {answerChoices.map((_, index) => {
          const count = counts[index] || 0;
          const percentage = calculatePercentage(count);

          return (
            <div key={index} className="correl-chart__bar-wrap">
              <div className="correl-chart__perc">{percentage}%</div>
              <div
                className="correl-chart__bar"
                style={{
                  height: `${percentage}%`,
                  backgroundColor: getBarColor(index),
                }}
              />
            </div>
          );
        })}
      </div>
      <div className="correl-chart__label">{answerLabel}</div>
    </div>
  );
}

export default CorrelChart;
